import AxiosInstanceCreator from 'services/api';
import {
  CreateNoticeReply,
  ReqFetchNotices,
  ReqUpdateNotice,
  ResNoticeDetail,
  ResNotices
} from '../models/notice.model';
import { BaseApiResponse, ResultBaseProps } from 'modules/common';
import qs from 'qs';

const noticeInstance = new AxiosInstanceCreator().create();

export const noticeApi = {
  /**
   * 공지사항 조회 및 검색
   * @param {noticeId, title, content, authorName, readCount, totalComment} data
   * @returns
   */
  async getNotices(query: string): Promise<ResNotices> {
    return noticeInstance.get(`notice?${query}`).then((res) => res.data);
  },

  /**
   * 공지사항 상세 조회
   * @param {noticeId, title, content, authorName, readCount, totalComment} data
   * @returns
   */
  async getNoticeDetail(id: string): Promise<ResNoticeDetail> {
    return noticeInstance.get(`/notice/${id}`).then((res) => res.data);
  },

  /**
   * 공지사항 등록
   * @param {noticeId, title, content, size} data
   * @returns
   */
  async createNotice(formData: FormData): Promise<ResultBaseProps> {
    return noticeInstance
      .post('/notice', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((res) => res.data);
  },

  /**
   * 공지사항 수정
   * @param {noticeModifyDto, files} data
   * @returns
   */
  async updateNotice(id: string, data: ReqUpdateNotice): Promise<ResultBaseProps> {
    return noticeInstance.patch(`/notice/${id}`, data).then((res) => res.data);
  },

  /**
   * 공지사항 삭제
   * @returns
   */
  async deleteNotice(id: string): Promise<ResultBaseProps> {
    return await noticeInstance.delete(`/notice/${id}`).then((res) => res.data);
  },

  /**
   * 공지사항 댓글 등록
   * @param {noticeId, commentContent} data
   * @returns
   */
  async creatNoticeReply(id: string, data: CreateNoticeReply): Promise<ResultBaseProps> {
    return noticeInstance.post(`/notice/${id}/reply`, data).then((res) => res.data);
  },

  /**
   * 공지사항 댓글 수정
   * @param {noticeCommentId, commentContent} data
   * @returns
   */
  async updateNoticeReply(replyId: string, data: string): Promise<ResultBaseProps> {
    return noticeInstance.patch(`/notice/reply/${replyId}`, data).then((res) => res.data);
  },

  /**
   * 공지사항 댓글 삭제
   * @param  {noticeCommentId}
   * @returns
   */
  async deleteNoticeReply(id: string): Promise<ResultBaseProps> {
    return noticeInstance.delete(`/notice/reply/${id}`).then((res) => res.data);
  },

  /**
   * 공지사항 사진 조회
   * @param {fileId} id
   * @returns
   */
  async getNoticePicAPI(id: string) {
    return await noticeInstance
      .get(`/notice/downloads/${id}`, { responseType: 'blob' })
      .then((res) => res.data);
  },

  /**
   * 공지사항 첨부파일 추가
   * @param {fileId} id
   * @returns
   */
  async createNoticeAttachment(noticeId: string, formData: FormData): Promise<ResultBaseProps> {
    return noticeInstance
      .post(`/notice/${noticeId}/attachment`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },

  /**
   * 공지사항 첨부파일 삭제
   * @param {fileId} id
   * @returns
   */
  async deleteNoticeAttachment(noticeId: string, fileId: string): Promise<ResultBaseProps> {
    return noticeInstance
      .delete(`/notice/${noticeId}/attachment/${fileId}`)
      .then((res) => res.data);
  }
};

export const noticeV2Api = {
  /**
   * 공지사항 조회 및 검색
   * @param {noticeId, title, content, authorName, readCount, totalComment} data
   * @returns
   */
  async fetchNotices(request: ReqFetchNotices): Promise<ResNotices> {
    return noticeInstance.get(`notice?${qs.stringify(request)}`).then((res) => res.data);
  },

  /**
   * 공지사항 상세 조회
   * @param {noticeId, title, content, authorName, readCount, totalComment} data
   * @returns
   */
  async getNoticeDetail(id: string): Promise<ResNoticeDetail> {
    return noticeInstance.get(`/notice/${id}`).then((res) => res.data);
  },

  /**
   * 공지사항 등록
   * @param {noticeId, title, content, size} data
   * @returns
   */
  async createNotice(formData: FormData): Promise<BaseApiResponse> {
    return noticeInstance
      .post('/notice', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((res) => res.data);
  },

  /**
   * 공지사항 수정
   * @param {noticeModifyDto, files} data
   * @returns
   */
  async updateNotice(id: string, data: ReqUpdateNotice): Promise<BaseApiResponse> {
    return noticeInstance.patch(`/notice/${id}`, data).then((res) => res.data);
  },

  /**
   * 공지사항 삭제
   * @returns
   */
  async deleteNotice(id: string): Promise<BaseApiResponse> {
    return noticeInstance.delete(`/notice/${id}`).then((res) => res.data);
  },

  /**
   * 공지사항 댓글 등록
   * @param {noticeId, commentContent} data
   * @returns
   */
  async creatNoticeReply(id: string, data: CreateNoticeReply): Promise<BaseApiResponse> {
    return noticeInstance.post(`/notice/${id}/reply`, data).then((res) => res.data);
  },

  /**
   * 공지사항 댓글 수정
   * @param {noticeCommentId, commentContent} data
   * @returns
   */
  async updateNoticeReply(replyId: string, data: string): Promise<BaseApiResponse> {
    return noticeInstance.patch(`/notice/reply/${replyId}`, data).then((res) => res.data);
  },

  /**
   * 공지사항 댓글 삭제
   * @param  {noticeCommentId}
   * @returns
   */
  async deleteNoticeReply(id: string): Promise<BaseApiResponse> {
    return noticeInstance.delete(`/notice/reply/${id}`).then((res) => res.data);
  },

  /**
   * 공지사항 사진 조회
   * @param {fileId} id
   * @returns
   */
  async getNoticePicAPI(id: string) {
    return await noticeInstance
      .get(`/notice/downloads/${id}`, { responseType: 'blob' })
      .then((res) => res.data);
  },

  /**
   * 공지사항 첨부파일 추가
   * @param {fileId} id
   * @returns
   */
  async createNoticeAttachment(noticeId: string, formData: FormData): Promise<BaseApiResponse> {
    return noticeInstance
      .post(`/notice/${noticeId}/attachment`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },

  /**
   * 공지사항 첨부파일 삭제
   * @param {fileId} id
   * @returns
   */
  async deleteNoticeAttachment(noticeId: string, fileId: string): Promise<BaseApiResponse> {
    return noticeInstance
      .delete(`/notice/${noticeId}/attachment/${fileId}`)
      .then((res) => res.data);
  }
};
